export default "/img/degrees.1a05648d04974505f31aac0d53c10870.svg";